export const POPUP_MESSAGES = [
  'Dear Valued Customers,',
  'Please be advised that all OWNDAYS outlets will operate with revised schedules on Wednesday, 26th March 2025, in conjunction with a company event. Kindly refer to the table below for the updated opening and closing times at each location. Additionally, our customer service hotline and online chat will end operations at 5:00 p.m. on that day.',

  'Normal operating hours will resume on Thursday, 27th March 2025.',

  'We apologize for any inconvenience this may cause and thank you for your understanding. We look forward to your continued support.',
];
